import { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { Button } from '../../../../Button';

type Props = {
  iconName?: IconProp;
  iconClasses?: string;
  title: string;
  tittleSavedSearch: string;
  dateString: string;
  filterCount: string;
  description: string;
  hasButton?: boolean;
  buttonComponent?: ReactElement<typeof Button>;
}

const SavedSearchWidgetCard = (props: Props): JSX.Element => {
  const { iconName, iconClasses, title, description, hasButton = false, buttonComponent, filterCount, tittleSavedSearch, dateString } = props;

  return (
    <div className='px-4 place-content-center rounded-2xl border-2 group w-full h-full'>
      <div className='block mb-3 mt-4'>
        {iconName && (
          <FontAwesomeIcon icon={iconName} className={`${iconClasses ?? ''} mr-2 text-2xl`} />
        )}
        <span className='mt-1 font-bold text-base'>{title}</span>
      </div>
      <div className='block text-sm mb-3'>
        <div>
            { tittleSavedSearch } saved { dateString }
            <br />
            <span className='font-bold'>{filterCount}</span> { description }
        </div>
      </div>
      {hasButton && (
        <div className='mb-4'>{ buttonComponent }</div>
      )}
    </div>
  );
};

export { SavedSearchWidgetCard };
